import React from "react";
import "./Herocontentl.css";
import hero from "../../assets/images/heroimg.png";
import navdot from "../../assets/images/hero-nav.svg";
import { useNavigate } from "react-router-dom";

function HerocontentB() {
  const navigate = useNavigate();
    const goToAbout = () => {
      navigate('/councellors');
    };
  return (
    <div className="hero-container-contact">
      <div className="hero-sec-content-contact">
          <h2>Explore Our Blogs</h2>
          
          <p> Discover expert insights, learning tips, and real-world guidance to help you succeed in education, career, and beyond. Whether you're a student, teacher, or lifelong learner—our blogs are here to inspire and inform your journey.</p>
          <button className="hero-sec-content-contact-btn" onClick={goToAbout}>More</button>
      </div>
    </div>
  );
}

export default HerocontentB;
